import { Component, Output, Input, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Dictionary, Utilities } from 'src/app/core/helper/util';
import { Log } from 'src/app/core/log';

/**
 * Sample usage:
  <bitwise-input [mainLabel]="'New Bitwise Test'" [bitwiseLabels]="bitwiseLabels"
  (selectionChanged)="testBitwiseChanged($event)"></bitwise-input>

  bitwiseValue: number = 0;
  bitwiseLabels: string [] = ['Option1', 'Option2', 'Option3'] ;
  testBitwiseChanged(bitwiseVal: number) {
    Log.debug('bitwise component test changed value: ' + bitwiseVal)
  }
 */
@Component({
  selector: 'app-bitwise-input',
  templateUrl: 'bitwise-input.html',
  styleUrls: ['bitwise-input.scss']
})
export class BitwiseInputComponent implements OnChanges {

  // outputs the new bitwise value
  @Output() selectionChanged: EventEmitter<number> = new EventEmitter();

  @Input() mainLabel: string;
  @Input() bitwiseValue: number;
  @Input() maxCount: number;

  @Input() bitwiseLabels: string[];
  @Input() bitwiseLabelsExterior: string[];

  exceededMax = false;
  idPrefix: string = Utilities.getRandomString(4);

  //bitwiseLabels: string [] = ['Option1', 'Option2', 'Option3'] ;
  bitwiseVals: number[] = [1, 2, 4, 8, 16, 32, 64, 128, 256, 512, 1024, 2048, 4096, 8192, 16384, 32768, 64536, 131072, 262144, 524288];
  bitwiseSelection: Dictionary<boolean> = {};

  private filter: string;

  constructor() {
    //Log.debug('bitwise input constructor for ' + this.mainLabel);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.initBitwise();
  }


  // this function should be run upon change of any selection, so the
  // actual value, bitwiseValue, is updated to reflected the change
  bitWiseChange(lbl: string) {
    //Log.debug('bitwise change happened on ' + lbl);
    this.bitwiseSelection[lbl] = !this.bitwiseSelection[lbl];
    let i = 1;
    let cumulativeValue = 0;
    let count = 0;
    this.bitwiseLabels.forEach(label => {
      if (this.bitwiseSelection[label] === true) {
        cumulativeValue |= i;
        count++;
      }
      i *= 2;
    });
    this.exceededMax = count > this.maxCount;

    this.bitwiseValue = cumulativeValue;

    this.selectionChanged.emit(this.bitwiseValue);
  }

  // this function initializes the values in the bitwiseSelection
  // using the bitwiseValue, should be called on load of the component
  private initBitwise() {
    Log.debug('init bitwise ' + this.mainLabel + ', bitwise value: ' + this.bitwiseValue);
    let i = 1;
    this.bitwiseLabels.forEach(label => {
      if (this.bitwiseSelection.hasOwnProperty(label) === false) {
        this.bitwiseSelection[label] = false;
      }
      this.bitwiseSelection[label] = ((this.bitwiseValue & i) === i);
      i *= 2;
    });
  }

}
